import {
  ArrowLongRightIcon,
  DocumentTextIcon,
  GlobeAltIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_DESTINATIONS } from "../../constants/routes";
import { DestinationTabs } from "../../enums/destination";
import Button from "../form/Button";

const EmptyDestinationsState = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-full">
      <div
        data-testid="empty-destinations-screen"
        className="flex w-full select-none flex-col items-center justify-center rounded-lg p-7 lg:p-20 border-subtle border border-dashed mb-16"
      >
        <div className="flex items-center gap-4">
          <div className="bg-gray-50 flex h-[72px] w-[72px] items-center justify-center rounded-full">
            <DocumentTextIcon className="size-8 text-gray-500" />
          </div>
          <ArrowLongRightIcon className="size-8 text-gray-400" />
          <div className="bg-gray-50 flex h-[72px] w-[72px] items-center justify-center rounded-full">
            <GlobeAltIcon className="size-8 text-gray-500" />
          </div>
        </div>

        <div className="mt-8 text-center">
          <h3 className="text-lg font-semibold text-gray-900">
            No Destinations Added
          </h3>
          <p className="mt-2 text-sm text-gray-500">
            Add your destination to start publishing articles automatically.
          </p>
        </div>

        <div className="mt-6">
          <Button
            variant="primary"
            onClick={() =>
              navigate(ROUTE_DESTINATIONS + `?tab=${DestinationTabs.ALL}`)
            }
          >
            Get Started
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmptyDestinationsState;
